import {createContext, FC, useContext, useState} from 'react'
import {WithChildren} from '@/_metronic/helpers'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import { FilterSubscription, initialFilter } from '@/app/modules/subscription/core/_models'

type SubscriptionQueryRequestContextProps = {
  state: BaseRequest<FilterSubscription>
  updateState: (updates: Partial<BaseRequest<FilterSubscription>>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<SubscriptionQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<BaseRequest<FilterSubscription>>(initialQueryRequest.state)

  const updateState = (updates: Partial<BaseRequest<FilterSubscription>>) => {
    const updatedState = {...state, ...updates} as BaseRequest<FilterSubscription>
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
